import React from 'react';
import ClientApplicationDetail from '~/components/ClientApplication/ClientApplicationDetail';
import BaseLayout from '~/layouts/BaseLayout';

class ClientApplicationDetailLayout extends BaseLayout {
  showProductHeading = true;

  renderMain() {
    return <ClientApplicationDetail />;
  }
}

export default ClientApplicationDetailLayout;
